import { render } from "./videoAid.vue?vue&type=template&id=294a995a"
import script from "./videoAid.vue?vue&type=script&lang=js"
export * from "./videoAid.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__